
import { computed, defineComponent, watch } from 'vue';

import { VueClassBinding } from '@/tools/types';

import { useAccordionCore } from './base/accordion/composable';

export default defineComponent({
	props: {
		expanded: {
			type: Boolean
		},

		disabled: {
			type: Boolean
		}
	},

	emits: ['opened', 'closed', 'update:expanded'],

	setup(props, { slots, emit }) {
		const { isExpanded, ...core } = useAccordionCore(props, slots, emit, { minHeight: '1em' });

		watch(isExpanded, () => {
			emit(isExpanded.value ? 'opened' : 'closed');
		});

		return {
			...core,

			triggerText: computed(() => {
				return isExpanded.value ? 'mniej' : 'więcej';
			}),

			accordionClasses: computed(
				(): VueClassBinding => ({ 'text-accordion--is-expanded': isExpanded.value })
			)
		};
	}
});
